import { render, staticRenderFns } from "./ReleasedElectrodeParaList.vue?vue&type=template&id=0227c51a&"
import script from "./ReleasedElectrodeParaList.vue?vue&type=script&lang=js&"
export * from "./ReleasedElectrodeParaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports